module.exports = __webpack_public_path__ + "img/Knee_NORE.f4049a13.jpg";